module.exports = __webpack_public_path__ + "static/media/sales-bg.234a7e61.jpg";